import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DialogButtonComponent } from '../buttons/dialog-button.component';
import { ModalService } from '../../services/modal.service';
import { OrderService } from '../../services/order.service';
import { SnackbarService } from '../../services/snackbar.service';
import { TranslateService } from '../../services/translate.service';
import moment from 'moment';
import { UserSpecificConfig } from '../../models/Order';
import {LoadingSpinnerComponent} from '../ui/loading-spinner-component';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    DialogButtonComponent,
    LoadingSpinnerComponent
  ],
  template: `
    <div class="bg-theme-surface rounded-2xl shadow-xl w-80">
      <div class="p-6 w-96 max-w-full relative">
        <h2 class="text-xl font-bold mb-4">{{ title }}</h2>
        <p class="mb-4">{{ range }}</p>

        <div *ngIf="config" class="mb-6">
          <div class="flex justify-center">
            <input
              type="time"
              [(ngModel)]="time"
              class="text-lg p-2 border text-theme-text bg-theme-surface2">
          </div>
          <div *ngIf="errorMessage" class="mt-2 text-theme-warning text-center font-semibold">
            {{ errorMessage }}
          </div>
        </div>

        <div class="flex gap-2 justify-end">
          <app-dialog-button
            [text]="getString('Stäng')"
            (onClick)="close()">
          </app-dialog-button>
          <app-dialog-button
            [text]="getString('OK')"
            [disabled]="isWorking"
            (onClick)="selectedTime()"
            variant="primary">
          </app-dialog-button>
        </div>
        <div *ngIf="isWorking" class="absolute bottom-8 left-6">
          <app-loading-spinner></app-loading-spinner>
        </div>
      </div>
    </div>
  `
})
export class SelectTimeDialogComponent implements OnInit {
  title?: string;
  config?: UserSpecificConfig;
  errorMessage?: string;
  isWorking = false;
  range?: string;
  time: any;

  constructor(
    @Inject('MODAL_DATA') public data: any,
    private modalService: ModalService,
    private order: OrderService,
    private snackbarService: SnackbarService,
    private translate: TranslateService
  ) {
    order.orderSnapshot().subscribe(res => {
      this.config = res.user_cfg;
      const lim = this.getTakeawayLimits();
      this.range = `${lim.min.format("HH:mm")} - ${lim.max.format("HH:mm")}`;
      this.title = this.getString('Välj upphämtningstid');
      const sug = this.roundDate(lim.min, moment.duration(5, "minutes"), "ceil");
      this.time = res.pickup_time ?? sug.format("HH:mm");
    });
  }

  ngOnInit(): void {}

  getString(s: string): string {
    return this.translate.getString(s);
  }

  close(): void {
    this.modalService.close();
  }

  private roundDate(date: moment.Moment, duration: moment.Duration, method: 'floor' | 'ceil' | 'round'): moment.Moment {
    return moment(Math[method]((+date) / (+duration)) * (+duration));
  }

  private getTakeawayLimits() {
    const ta = this.config!.takeaway!;
    const minMinutes = ta.cooking_time + ta.pickup_add;
    const minMoment = moment().add(minMinutes, 'm');
    const maxMoment = moment(ta.closing_time, "HH:mm");
    return { min: minMoment, max: maxMoment };
  }

  selectedTime(): void {
    const lim = this.getTakeawayLimits();
    const selMoment = moment(this.time, "HH:mm");

    if (selMoment.isBetween(lim.min, lim.max)) {
      this.isWorking = true;
      this.order.updateCollected(undefined, this.time, undefined, undefined).subscribe({
        next: () => {
          this.isWorking = false;
          this.modalService.close();
        },
        error: (err) => {
          this.isWorking = false;
          this.snackbarService.showMessage(this.getString("Något gick fel"));
        }
      });
    } else {
      this.errorMessage = this.getString("Välj en tid mellan") + ` ${lim.min.format("HH:mm")} - ${lim.max.format("HH:mm")}`;
    }
  }
}
